import { create } from "zustand";

export const paginadorAlertasStore = create((set) => ({
    filtros: null,
    editarFiltros: (data) => set({ filtros: data }),
    cargando: false,
    editarCargando: (data) => set({ cargando: data }),
    datos: [],
    editarDatos: (data) => set({ datos: data }),
    paginaActual: 1,
    editarPaginaActual: (data) => set({ paginaActual: data }),
    totalPaginas: 1,
    editarTotalPaginas: (data) => set({ totalPaginas: data }),
    totalDatos: 0,
    editarTotalDatos: (data) => set({ totalDatos: data }),
    datosCargados: 0,
    editarDatosCargados: (data) => set({ datosCargados: data }),
    progresoCargado: 0,
    editarProgresoCargado: (data) => set({ progresoCargado: data }),
    paginasNoCargadas: [],
    editarPaginasNoCargadas: (data) => set({ paginasNoCargadas: data }),
    cargaCompletada: false,
    editarCargaCompletada: (data) => set({ cargaCompletada: data }),
    error: '',
    editarError: (data) => set({ error: data }),
    reiniciar: () => {
        set({
            datos: [],
            progresoCargado: 0,
            totalDatos: 0,
            cargando: false,
            error: null,
            paginaActual: 1,
            totalPaginas: 1,
            datosCargados: 0,
            paginasNoCargadas: [],
            cargaCompletada: false,
            tieneError: false
        });
    }
}));

export const paginadorAlertasAfterStore = create((set) => ({
    filtros: null,
    editarFiltros: (data) => set({ filtros: data }),
    cargando: false,
    editarCargando: (data) => set({ cargando: data }),
    datos: [],
    editarDatos: (data) => set({ datos: data }),
    paginaActual: 1,
    editarPaginaActual: (data) => set({ paginaActual: data }),
    totalPaginas: 1,
    editarTotalPaginas: (data) => set({ totalPaginas: data }),
    totalDatos: 0,
    editarTotalDatos: (data) => set({ totalDatos: data }),
    datosCargados: 0,
    editarDatosCargados: (data) => set({ datosCargados: data }),
    progresoCargado: 0,
    editarProgresoCargado: (data) => set({ progresoCargado: data }),
    paginasNoCargadas: [],
    editarPaginasNoCargadas: (data) => set({ paginasNoCargadas: data }),
    cargaCompletada: false,
    editarCargaCompletada: (data) => set({ cargaCompletada: data }),
    error: '',
    editarError: (data) => set({ error: data }),
    reiniciar: () => {
        set({
            datos: [],
            progresoCargado: 0,
            totalDatos: 0,
            cargando: false,
            error: null,
            paginaActual: 1,
            totalPaginas: 1,
            datosCargados: 0,
            paginasNoCargadas: [],
            cargaCompletada: false,
            tieneError: false
        });
    }
}));

export const paginadorAlertasBeforeStore = create((set) => ({
    filtros: null,
    editarFiltros: (data) => set({ filtros: data }),
    cargando: false,
    editarCargando: (data) => set({ cargando: data }),
    datos: [],
    editarDatos: (data) => set({ datos: data }),
    paginaActual: 1,
    editarPaginaActual: (data) => set({ paginaActual: data }),
    totalPaginas: 1,
    editarTotalPaginas: (data) => set({ totalPaginas: data }),
    totalDatos: 0,
    editarTotalDatos: (data) => set({ totalDatos: data }),
    datosCargados: 0,
    editarDatosCargados: (data) => set({ datosCargados: data }),
    progresoCargado: 0,
    editarProgresoCargado: (data) => set({ progresoCargado: data }),
    paginasNoCargadas: [],
    editarPaginasNoCargadas: (data) => set({ paginasNoCargadas: data }),
    cargaCompletada: false,
    editarCargaCompletada: (data) => set({ cargaCompletada: data }),
    error: '',
    editarError: (data) => set({ error: data }),
    reiniciar: () => {
        set({
            datos: [],
            progresoCargado: 0,
            totalDatos: 0,
            cargando: false,
            error: null,
            paginaActual: 1,
            totalPaginas: 1,
            datosCargados: 0,
            paginasNoCargadas: [],
            cargaCompletada: false,
            tieneError: false
        });
    }
}));

export const paginadoKilometrajeStore = create((set) => ({
    filtros: null,
    editarFiltros: (data) => set({ filtros: data }),
    cargando: false,
    editarCargando: (data) => set({ cargando: data }),
    datos: [],
    editarDatos: (data) => set({ datos: data }),
    paginaActual: 1,
    editarPaginaActual: (data) => set({ paginaActual: data }),
    totalPaginas: 1,
    editarTotalPaginas: (data) => set({ totalPaginas: data }),
    totalDatos: 0,
    editarTotalDatos: (data) => set({ totalDatos: data }),
    datosCargados: 0,
    editarDatosCargados: (data) => set({ datosCargados: data }),
    progresoCargado: 0,
    editarProgresoCargado: (data) => set({ progresoCargado: data }),
    paginasNoCargadas: [],
    editarPaginasNoCargadas: (data) => set({ paginasNoCargadas: data }),
    cargaCompletada: false,
    editarCargaCompletada: (data) => set({ cargaCompletada: data }),
    error: '',
    editarError: (data) => set({ error: data }),
    reiniciar: () => {
        set({
            datos: [],
            progresoCargado: 0,
            totalDatos: 0,
            cargando: false,
            error: null,
            paginaActual: 1,
            totalPaginas: 1,
            datosCargados: 0,
            paginasNoCargadas: [],
            cargaCompletada: false,
            tieneError: false
        });
    }
}));

export const paginadoRecorridosStore = create((set) => ({
    filtros: null,
    editarFiltros: (data) => set({ filtros: data }),
    cargando: false,
    editarCargando: (data) => set({ cargando: data }),
    datos: [],
    editarDatos: (data) => set({ datos: data }),
    paginaActual: 1,
    editarPaginaActual: (data) => set({ paginaActual: data }),
    totalPaginas: 1,
    editarTotalPaginas: (data) => set({ totalPaginas: data }),
    totalDatos: 0,
    editarTotalDatos: (data) => set({ totalDatos: data }),
    datosCargados: 0,
    editarDatosCargados: (data) => set({ datosCargados: data }),
    progresoCargado: 0,
    editarProgresoCargado: (data) => set({ progresoCargado: data }),
    paginasNoCargadas: [],
    editarPaginasNoCargadas: (data) => set({ paginasNoCargadas: data }),
    cargaCompletada: false,
    editarCargaCompletada: (data) => set({ cargaCompletada: data }),
    error: '',
    editarError: (data) => set({ error: data }),
    reiniciar: () => {
        set({
            datos: [],
            progresoCargado: 0,
            totalDatos: 0,
            cargando: false,
            error: null,
            paginaActual: 1,
            totalPaginas: 1,
            datosCargados: 0,
            paginasNoCargadas: [],
            cargaCompletada: false,
            tieneError: false
        });
    }
}));